import { OgpApiService } from './ogp-api-service';
import {
  ServiceAgreementDetailResponse,
  ServiceAgreementFilterPayload,
  ServiceAgreementsResponse,
} from './service-agreements.types';

export class ServiceAgreementsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getServiceAgreementsForCompany = async (relation?: ServiceAgreementFilterPayload) => {
    return await this.ogpApiService.get<ServiceAgreementsResponse>({
      path: 'service-agreements',
      params: {
        isLender: relation?.isLender,
        isBorrower: relation?.isBorrower,
        oppositeParty: relation?.oppositeParty,
      },
    });
  };

  public getServiceAgreementById = async (id: string) => {
    return await this.ogpApiService.get<ServiceAgreementDetailResponse>({
      path: `service-agreements/${id}`,
    });
  };

  public acceptServiceAgreement = async (id: string) => {
    return await this.ogpApiService.update({
      path: `service-agreements/${id}/accept`,
    });
  };

  public rejectServiceAgreement = async (id: string) => {
    return await this.ogpApiService.update({
      path: `service-agreements/${id}/reject`,
    });
  };
}
